import { Chip, Typography, Link } from "@mui/material";
import React from "react";
import { useLocale } from "../../providers/LocaleProvider";
import RemoveIcon from "../../resources/images/icons-remove.svg";

interface CompetenciesChipFilterProps {
  filterRef: any;
  onRemove: (key: string, value: any) => void;
  onRemoveAll: () => void;
}

const CompetenciesChipFilter = ({
  filterRef,
  onRemove,
  onRemoveAll
}: CompetenciesChipFilterProps) => {
  const { translate } = useLocale();
  const objectEntries = React.useMemo(() => {
    return Object.entries(filterRef).sort((a, b) => {
      return a[0].localeCompare(b[0]);
    });
  }, [filterRef]);

  const hasFilters = React.useMemo(() => {
    return objectEntries.some(([_, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== null && value !== undefined && value !== "";
    });
  }, [objectEntries]);

  return (
    <React.Fragment>
      {objectEntries.map(([key, value]) => {
        if (Array.isArray(value)) {
          return (
            <React.Fragment key={key}>
              {value.map((item) => (
                <Chip
                  key={`${key}-${item.id || item}`}
                  label={
                    <>
                      <Typography sx={{ textTransform: "capitalize", fontSize: ".875rem" }}>
                        {key}: <b>{item.name || item}</b>
                      </Typography>
                    </>
                  }
                  onDelete={() =>
                    onRemove(
                      key,
                      value.filter((i: any) => i !== item)
                    )
                  }
                  deleteIcon={<RemoveIcon />}
                />
              ))}
            </React.Fragment>
          );
        }

        if (value === null || value === undefined || value === "") {
          return <></>;
        }

        return (
          <Chip
            key={key}
            label={
              <Typography sx={{ textTransform: "capitalize", fontSize: ".875rem" }}>
                {key}:{" "}
                <b>
                  {typeof value === "boolean"
                    ? value
                      ? translate("common.yes")
                      : translate("common.no")
                    : value.toString()}
                </b>
              </Typography>
            }
            onDelete={() => onRemove(key, null)}
            deleteIcon={<RemoveIcon />}
          />
        );
      })}

      {hasFilters && (
        <Link
          component='button'
          underline='none'
          onClick={onRemoveAll}
          sx={{ fontSize: ".875rem", ml: 1, height: "32px !important" }}
        >
          {translate("common.clearAll")}
        </Link>
      )}
    </React.Fragment>
  );
};

export default CompetenciesChipFilter;
